import React from "react";
import { PatientMissingDocsTemplateEditTemplate } from "themes/application/patient-missing-docs/components";
import { observer } from "mobx-react";

@observer
class PatientMissingDocsTemplateEdit extends React.Component {
	render() {
		return <PatientMissingDocsTemplateEditTemplate {...this.props} />;
	}
}

export default PatientMissingDocsTemplateEdit;